export default "__VITE_ASSET__e86a7fbe__"